import { useEffect, useState } from "react";
import { io, Socket } from "socket.io-client";
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "http://localhost:3002";

export const useSocket = (userId: string, tenantId: string) => {
  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    if (!userId || !tenantId) return;
    const socketInstance = io(SOCKET_URL, {
      transports: ["websocket", "polling"],
    });

    socketInstance.on("connect", () => {
      socketInstance.emit("subscribeToNotifications", { userId, tenantId });
    });

    setSocket(socketInstance);

    return () => {
      socketInstance.disconnect();
    };
  }, [userId, tenantId]);

  return socket;
};